import { render, staticRenderFns } from "./file-loader-details-sheet.vue?vue&type=template&id=0f37853b&scoped=true"
import script from "./file-loader-details-sheet.vue?vue&type=script&lang=js"
export * from "./file-loader-details-sheet.vue?vue&type=script&lang=js"
import style0 from "./file-loader-details-sheet.vue?vue&type=style&index=0&id=0f37853b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37853b",
  null
  
)

export default component.exports